import {API_BASE_PATH} from "../restConstants";
import rest from "../axiosRestCalls";

const API = API_BASE_PATH;

class emailService {
    postEmail(date, firstName, lastName, toAddresss, quoteImage) {
        const url = API + '/email/send';
        const data = new FormData();
        data.append('date', date);
        data.append('firstName', firstName);
        data.append('lastName', lastName);
        data.append('toAddress', toAddresss);
        data.append('quoteImage', quoteImage, 'quote.png');

        rest.post(url, data, {
            headers: {
                'content-type': `multipart/form-data`
            }
        }).then((response) => {
            console.log(response);
        }, (error) => {
            console.log(error);
        })
    }
}
// eslint-disable-next-line
export default new emailService();
